import { render } from "./ContentWrap.vue?vue&type=template&id=211ed61e&scoped=true"
import script from "./ContentWrap.vue?vue&type=script&lang=js"
export * from "./ContentWrap.vue?vue&type=script&lang=js"

import "./ContentWrap.vue?vue&type=style&index=0&id=211ed61e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-211ed61e"]])

export default __exports__